.header {
  display: grid;
  gap: var(--space-4);
  padding: var(--space-6) var(--gutter) 0;
  /* Bounded, so on a wide monitor the title does not end up a hand's width
     from the actions with nothing between them. */
  max-width: var(--content-max-wide);
}

.top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
}

.headings {
  display: grid;
  gap: var(--space-2);
  min-width: 0;
}

/*
 * The accent, not --text-faint. The eyebrow is now the only thing above the
 * title: the sentence that used to explain each page has been removed
 * everywhere, and a faint grey label in that position reads as leftover
 * furniture rather than as the page's identity. --accent-text and not --accent,
 * because raw Sahel measures 2.12:1 on Harmattan and this is text at eleven
 * pixels.
 */
.eyebrow {
  font: var(--type-label);
  letter-spacing: var(--tracking-label);
  text-transform: uppercase;
  color: var(--accent-text);
}

.title {
  font: var(--type-title);
  color: var(--text);
}

/*
 * The description runs to the prose measure, not to the width of the page.
 * At 90rem a two-sentence paragraph becomes one line of about 200 characters,
 * which is roughly three times the length the eye can track back from.
 */
.description {
  max-width: var(--content-max);
  font: var(--type-body);
  color: var(--text-muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  /* Sits with the title's baseline rather than with the description's, because
     an action belongs to the page and not to the sentence explaining it. */
  align-self: flex-end;
}

.extra {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

/*
 * Flush with the bottom, and the rule spans the full gutter rather than the
 * content, so the tabs sit on a line that reaches the edges of the page the
 * way a real tab strip does.
 */
.tabs {
  margin: var(--space-2) calc(var(--gutter) * -1) 0;
  padding: 0 var(--gutter);
  border-bottom: 1px solid var(--rule);
}
